import { HTMLProps } from 'react';

import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginLeft: 'auto',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
  });

export interface AppHeaderAuxProps
  extends HTMLProps<HTMLDivElement>,
    WithStyles<typeof styles> {}

const AppHeaderAux = (props: AppHeaderAuxProps) => {
  const { className, classes, ...rest } = props;
  return <div className={classNames(classes.root, className)} {...rest} />;
};

export default withStyles(styles)(AppHeaderAux);
